import React from "react";

const Skill = ({ skill }) => {
  const percentage = Number(skill.percent);

  return (
    <div className="skills_data">
      <div className="skills_titles">
        <h3 className="skills_name">{skill.name}</h3>
        <span className="skills_number">{skill.percent}%</span>
      </div>
      <div className="skills_bar">
        <span
          style={{ width: `${percentage}%` }}
          className="skills_percentage skills_html"
        ></span>
      </div>
    </div>
  );
};

export default Skill;
